import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

const SUPABASE_URL = "https://yhcymqfdigeufzooutxi.supabase.co";
const SUPABASE_FUNCTIONS_URL = "https://yhcymqfdigeufzooutxi.functions.supabase.co";

export function DiagnosticsHeader() {
  const [out, setOut] = useState('(checking...)');

  useEffect(() => {
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const user = session?.user || null;
      
      setOut([
        `Session: ${session ? 'yes' : 'no'}`,
        user ? `User: ${user.email || user.id}` : '',
        `Supabase URL: ${SUPABASE_URL}`,
        `Functions URL: ${SUPABASE_FUNCTIONS_URL}`,
        `Time: ${new Date().toLocaleString()}`
      ].filter(Boolean).join('\n'));
    })();
  }, []);

  return (
    <div className="border rounded p-3 bg-warning/10">
      <pre className="text-xs whitespace-pre-wrap">{out}</pre>
    </div>
  );
}